import {InterfaceNews} from "../../../interface/press-center/interface.news";

export class NewsCategoryService {
    constructor(private loader: HTMLElement | null) {
    }

    async getNewsCategory(): Promise<InterfaceNews | null> {
        this.loader?.classList.add('active');
        try {
            const response = await fetch(
                '/api/press-center/news/category', {
                    method: 'GET',
                    headers: {
                        'Authorization': 'true'
                    },
                });
            const data: InterfaceNews = await response.json();
            this.loader?.classList.remove('active');
            return data;

        } catch (error) {
            this.loader?.classList.remove('active');

            return null;
        }
    }
}
